import React, { useState } from "react";
import { IoMdAdd } from "react-icons/io";
import ReportUsersList from "./ReportUsersList/ReportUsersList";

export default function ReportUsers() {
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);

  const openAddUserModal = () => {
    setIsAddUserModalOpen(true);
  };

  const closeAddUserModal = () => {
    setIsAddUserModalOpen(false);
  };

  return (
    <section className="p-2">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-black">Report Users </h1>
        <button
          onClick={openAddUserModal}
          className="bg-[var(--primary-color)] text-md text-white rounded-full px-4 py-2.5 flex items-center gap-2 font-medium hover:opacity-60"
        >
          <IoMdAdd />
          Add User
        </button>
      </div>

      <ReportUsersList
        openAddUserModal={openAddUserModal}
        isAddUserModalOpen={isAddUserModalOpen}
        closeAddUserModal={closeAddUserModal}
      />
    </section>
  );
}
